import { Component} from '@angular/core';

@Component({
    selector: 'donationCategory-main',
    templateUrl: './donationCategory-main.tmpl.html'
})

export class DonationCategoryMain {
    editMode: boolean = null;

    public setVal(val:boolean) {
        this.editMode = val;
    }
}
